<template>
    <v-container fluid>
        <branch-card
            :title="`Branch Transfer List`"
            :btnText="`Initiate New Branch Transfer Request`"
            :showActionBtn="shouldShowActionBtn()"
            :btnTo="{name: 'initiateBranchTransfer'}"
        >
          <branch-filter
            @setStartDate="setStartDate"
            @setEndDate = "setEndDate"
            @setEnrollmentCode="setEnrollmentCode"
            @callApi = "getBranchTransferRequest"
            @reset="handleReset"
          />
          <branch-table :branchListArray="branchListArray" :isSuperAdmin="isSuperAdmin"/>
        </branch-card>
    </v-container>
</template>
<script>
import stores from '@/stores'
import constants from '@/utils/constants'
import BranchCard from '@/components/BranchTransferV1/component/branchCardComponent'
import BranchFilter from '@/components/BranchTransferV1/component/filter/filterComponent'
import BranchTable from '@/components/BranchTransferV1/component/table/branchTransferTable'
export default {
  name: 'branchTransferList',
  components: {
    BranchCard,
    BranchFilter,
    BranchTable
  },
  data () {
    return {
      branchListArray: [],
      startDate: null,
      endDate: null,
      enrollmentCode: null,
      userRoles: stores.user.roles || [],
      centerHeadRoles: ['FRANCHISEE_USER_1', 'CH_LEVEL1', 'CH_LEVEL2', 'CH_LEVEL3'],
      isCenterHead: false,
      zomRoles: ['BUSINESS_DEVELOPER'],
      isZom: false
    }
  },
  computed: {
    franchisee: {
      get () {
        return this.$store.state.franchisee
      }
    },
    academicYear: {
      get () {
        return this.$store.state.academicYear
      }
    },
    isSuperAdmin: function () {
      return stores.user.me.superAdmin
    }
  },
  watch: {
    franchisee: function (newVal, oldVal) {
      if (newVal !== oldVal && this.academicYear) {
        this.getBranchTransferRequest()
      }
    },
    academicYear: function (newVal, oldVal) {
      if (newVal !== oldVal && this.franchisee && this.franchisee.id) {
        this.getBranchTransferRequest()
      }
    }
  },
  created () {
    // this.isCenterHead = this.checkBranchTransferAccess(this.centerHeadRoles)
    this.isZom = this.checkBranchTransferAccess(this.zomRoles)
    if (this.franchisee && this.franchisee.id && this.academicYear) {
      this.getBranchTransferRequest()
    }
  },
  methods: {
    async handleReset () {
      this.startDate = null
      this.endDate = null
      this.enrollmentCode = null
      await this.getBranchTransferRequest()
    },
    shouldShowActionBtn () {
      // return this.isSuperAdmin || this.isCenterHead
      return this.isSuperAdmin || this.isZom
    },
    checkBranchTransferAccess (roleList) {
      return this.userRoles?.some(item => roleList.includes(item.role))
    },
    setStartDate: function (newVal) {
      this.startDate = newVal
    },
    setEndDate: function (newVal) {
      this.endDate = newVal
    },
    setEnrollmentCode: function (newVal) {
      this.enrollmentCode = newVal
    },
    getBranchTransferRequest: async function () {
      try {
        let payload = {}
        if ((this.startDate && !this.endDate) || (!this.startDate && this.endDate)) {
          return this.errMsg('Please select start date and end date.')
        }
        if (this.franchisee && !this.franchisee.id) {
          let franchiseeObj = stores.user.franchisee
          if (franchiseeObj && franchiseeObj.id) {
            payload.franchiseeID = franchiseeObj.id
          } else {
            return this.errMsg('Please select franchisee.')
          }
        } else if (this.franchisee && this.franchisee.id) {
          payload.franchiseeID = this.franchisee.id
        } else {
          return this.errMsg('Please select franchisee.')
        }

        if (!this.academicYear) {
          let academicYearObj = stores.user.academicYear
          if (academicYearObj && academicYearObj.id) {
            payload.academicYearID = academicYearObj.id
          } else {
            return this.errMsg('Please select academic year.')
          }
        } else if (this.academicYear) {
          payload.academicYearID = this.academicYear.id
        } else {
          return this.errMsg('Please select academic year.')
        }
        if (this.startDate && this.endDate) {
          payload.startDate = this.startDate
          payload.endDate = this.endDate
        }
        if (this.enrollmentCode) {
          payload.enrollmentCode = this.enrollmentCode
        }
        let res = await http.post(`${constants.API_URL}/api/v1/branch-transfer/get-branch-transfer-request`, payload)
        if (res.status === 200) {
          this.branchListArray = res.data
          this.branchListArray = this.branchListArray.map(item => {
            return {
              ...item,
              // isOldCH: this.isCenterHead && item.fromFranchiseeID === stores.user?.franchisee?.id
              isZOM: this.isZom
            }
          })
        } else {
          this.errMsg('Failed to create new branch request.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    }
  }
}
</script>
